import { Box, Skeleton, Typography } from '@mui/material';

import { AGGREGATE_INFO } from './constants';
import { LinkItem } from './LinkItem';
import React from 'react';
import clsx from 'clsx';
import { groupByAction } from '../../GlobalSearch/SearchModal/components/ResultListGroups/ResultListGroups';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    overflowY: 'auto',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    maxWidth: '100%',
  },
}));

const LinksSkeleton = ({ styles }) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Typography className={styles.info} sx={{ mb: 1 }}>
        <Skeleton width={60} height={24} />
      </Typography>
      <Box className={classes.content} sx={{ gap: 2, mb: 2 }}>
        {[1, 2, 3].map((i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            width={100}
            height={32}
            sx={{ borderRadius: 1 }}
          />
        ))}
      </Box>
      <Typography className={styles.info} sx={{ mb: 1 }}>
        <Skeleton width={80} height={24} />
      </Typography>
      <Box className={classes.content} sx={{ gap: 2, mb: 2 }}>
        {[1, 2].map((i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            width={120}
            height={32}
            sx={{ borderRadius: 1 }}
          />
        ))}
      </Box>
    </Box>
  );
};

export const Links = ({ rows, aggregate, loading, onActionClick, styles = {} }) => {
  const classes = useStyles();
  const rowsGroupedByAction = groupByAction(rows);
  const { links, downloads } = AGGREGATE_INFO[aggregate] || { links: [], downloads: [] };

  if (loading) {
    return <LinksSkeleton styles={styles} />;
  }

  if (!rows?.length) {
    return (
      <Box className={classes.root}>
        <Typography className={styles.info}>No links available</Typography>
      </Box>
    );
  }

  return (
    <Box
      className={clsx({
        [classes.root]: true,
        [styles.resultListGroupRoot]: !!styles.resultListGroupRoot,
      })}
      data-testid="gs-results"
    >
      {links.length > 0 && (
        <Typography className={clsx({ [styles.info]: true, [styles.bold]: true })}>
          See in:
        </Typography>
      )}
      <Box
        className={clsx({
          [classes.content]: true,
          [styles.resultListGroupContent]: !!styles.resultListGroupContent,
        })}
      >
        {links.map((type) => {
          const rows = rowsGroupedByAction[type.action];
          if (!rows?.length) return null;

          return (
            <LinkItem key={type.action} rows={rows} type={type} onActionClick={onActionClick} />
          );
        })}
      </Box>
      {downloads.length > 0 && (
        <Typography className={clsx({ [styles.info]: true, [styles.bold]: true })}>
          Download:
        </Typography>
      )}
      <Box
        className={clsx({
          [classes.content]: true,
          [styles.resultListGroupContent]: !!styles.resultListGroupContent,
        })}
      >
        {downloads.map((type) => {
          const rows = rowsGroupedByAction[type.action];
          if (!rows?.length) return null;

          return (
            <LinkItem key={type.action} rows={rows} type={type} onActionClick={onActionClick} />
          );
        })}
      </Box>
    </Box>
  );
};
